import React from 'react';
import { Check, X, Send } from 'lucide-react';
import { useLeadForm } from '../LeadFormContext';
const kubotaFeatures = ['Гарантия 3 года или 1500 моточасов', 'Экономичный расход топлива', 'Кабина с кондиционером (серия M — в базе)', 'Программы лизинга', 'Высокая остаточная стоимость'];
const chinaDrawbacks = ['Сомнительная гарантия', 'Высокий расход топлива', 'Низкое качество сборки', 'Нет запчастей в наличии', 'Быстрая потеря стоимости'];
export function PriceComparison() {
  const {
    openForm
  } = useLeadForm();
  return <section className="bg-[#0A1A3F] text-white px-5 py-14 md:px-12 lg:px-24" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <h2 className="font-heading font-bold text-[28px] md:text-[36px] text-center mb-3" data-id="element-97">
          Kubota vs дешёвые аналоги
        </h2>
        <p className="text-center text-white/55 text-sm md:text-base mb-8 max-w-lg mx-auto" data-id="element-98">
          Экономия на покупке оборачивается переплатой на ремонте и простоях
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5" data-id="element-99">
          {/* Kubota card */}
          <div className="border-2 border-[#25D366] bg-[#25D366]/8 rounded-2xl p-5 md:p-6" data-id="element-100">
            <h3 className="font-heading font-bold text-lg md:text-xl text-[#25D366] mb-4" data-id="element-101">
              Kubota
            </h3>
            <ul className="space-y-3" data-id="element-102">
              {kubotaFeatures.map(f => <li key={f} className="flex items-start gap-2.5" data-id="element-103">
                  <Check className="w-5 h-5 text-[#25D366] shrink-0 mt-0.5" data-id="element-104" />
                  <span className="text-sm md:text-base text-white/90" data-id="element-105">
                    {f}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Cheap alternatives card */}
          <div className="border border-white/15 bg-white/5 rounded-2xl p-5 md:p-6 opacity-70" data-id="element-106">
            <h3 className="font-heading font-bold text-lg md:text-xl text-white/60 mb-4" data-id="element-107">
              Дешёвые аналоги
            </h3>
            <ul className="space-y-3" data-id="element-108">
              {chinaDrawbacks.map(d => <li key={d} className="flex items-start gap-2.5" data-id="element-109">
                  <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-110" />
                  <span className="text-sm md:text-base text-white/55" data-id="element-111">
                    {d}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* CTA */}
        <button onClick={openForm} className="flex items-center justify-center gap-2.5 w-full bg-[#25D366] hover:bg-[#1da851] text-white font-heading font-bold text-lg min-h-[56px] rounded-2xl transition-colors mt-8 cursor-pointer" data-id="element-112">
          <Send className="w-5 h-5" data-id="element-113" />
          Рассчитать экономию
        </button>
      </div>
    </section>;
}